module.exports = __webpack_public_path__ + "img/joseph.8a628c13.png";